'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var magicFormBuilder = require('@gig/magic-form-builder');
var magicSdk = require('@gig/magic-sdk');
var tslib = require('tslib');

function nationality() {
    var _this = this;
    return {
        id: 'nationality-wrapper',
        component: 'magic-ui-form-field',
        isDataField: false,
        validationBase: 'nationalityCode',
        testId: 'step2-nationality',
        children: [
            {
                id: 'nationalityCode',
                component: 'magic-ui-dropdown',
                isDataField: true,
                properties: {
                    placeholder: magicCommon.translate('sign-up-step-two.nationality'),
                },
                validation: [
                    {
                        name: 'required',
                        fn: magicFormBuilder.required,
                    },
                ],
                preloadProperties: function () { return tslib.__awaiter(_this, void 0, void 0, function () {
                    var nationalities;
                    return tslib.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, magicSdk.magic.invokeCached(60, magicSdk.magic.methods.signup, 'getNationalities')()];
                            case 1:
                                nationalities = (_a.sent());
                                return [2 /*return*/, {
                                        options: nationalities.map(function (_a) {
                                            var name = _a.name, alphaCode2 = _a.alphaCode2;
                                            return ({
                                                name: name,
                                                value: alphaCode2,
                                            });
                                        }),
                                    }];
                        }
                    });
                }); },
            },
        ],
    };
}

exports.nationality = nationality;
